import { Stack } from 'expo-router';

/**
 * Workouts sidebar stack: the list (`index`) and the detail flow (`(detail)`
 * group, which carries its own header + full-height chrome). Lives inside the
 * `(sidebar)` group so the desktop sidebar stays visible on detail screens. The
 * AI Coach rail is declared by the `(detail)` layout (workout builder), not
 * here, so the workouts index stays rail-free.
 */
export default function WorkoutsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="(detail)" />
    </Stack>
  );
}
